import Phaser from 'phaser';

const TAP_THRESHOLD_MS = 180;

type Listener = () => void;

export class InputManager {
  private scene: Phaser.Scene;
  private upKey: Phaser.Input.Keyboard.Key;
  private spaceKey: Phaser.Input.Keyboard.Key;
  private downKey: Phaser.Input.Keyboard.Key;

  private downAt = 0;
  private downHeld = false;
  private holdEmitted = false;

  private jumpListeners: Listener[] = [];
  private duckTapListeners: Listener[] = [];
  private holdStartListeners: Listener[] = [];
  private holdEndListeners: Listener[] = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    const kb = scene.input.keyboard!;
    this.upKey = kb.addKey(Phaser.Input.Keyboard.KeyCodes.UP);
    this.spaceKey = kb.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
    this.downKey = kb.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN);

    this.downKey.on('down', this.handleDownPress, this);
    this.downKey.on('up', this.handleDownRelease, this);
    // Touch input is handled by the on-screen UP/DOWN buttons in GameScene.
  }

  destroy(): void {
    this.downKey.off('down', this.handleDownPress, this);
    this.downKey.off('up', this.handleDownRelease, this);
  }

  // External entry points for on-screen buttons.
  triggerJump(): void {
    this.emit(this.jumpListeners);
  }
  pressDown(): void {
    this.handleDownPress();
  }
  releaseDown(): void {
    this.handleDownRelease();
  }

  onJump(fn: Listener): void {
    this.jumpListeners.push(fn);
  }
  onDuckTap(fn: Listener): void {
    this.duckTapListeners.push(fn);
  }
  onDuckHoldStart(fn: Listener): void {
    this.holdStartListeners.push(fn);
  }
  onDuckHoldEnd(fn: Listener): void {
    this.holdEndListeners.push(fn);
  }

  update(): void {
    // Edge-detect jump from keyboard.
    if (
      Phaser.Input.Keyboard.JustDown(this.spaceKey) ||
      Phaser.Input.Keyboard.JustDown(this.upKey)
    ) {
      this.emit(this.jumpListeners);
    }

    // Promote a held DOWN to hold-start once threshold has elapsed.
    if (this.downHeld && !this.holdEmitted) {
      const now = this.scene.time.now;
      if (now - this.downAt >= TAP_THRESHOLD_MS) {
        this.holdEmitted = true;
        this.emit(this.holdStartListeners);
      }
    }
  }

  private handleDownPress(): void {
    this.downAt = this.scene.time.now;
    this.downHeld = true;
    this.holdEmitted = false;
  }

  private handleDownRelease(): void {
    this.downHeld = false;
    if (this.holdEmitted) {
      this.emit(this.holdEndListeners);
    } else {
      this.emit(this.duckTapListeners);
    }
    this.holdEmitted = false;
  }

  private emit(listeners: Listener[]): void {
    for (const fn of listeners) fn();
  }
}
